import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase';
import SingleResultRound from './SingleResultRound';

function AllResultsRound({draw, hostcupId, roundId}) {

    const [results, setResults] = useState([]);
    const [activeItem, setActiveItem] = useState("1")

    useEffect(() => {

        try {
            const resultsRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("results");
            resultsRef.orderBy("kamp_nr").where("draw", "==", draw).onSnapshot(({docs}) => {
                const results = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setResults(results);
            })
        } catch (error) {
            console.log(error)
        }

    }, [])

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    return (
        <React.Fragment>
            <div className="row my-2">
                <div className="col-6">
                    <button onClick={() => toggle("2")} className={`btn btn-block btn-primary ${activeItem === "2" && "active"}`}>Vis kun resultater</button>
                </div>
                <div className="col-6">
                    <button onClick={() => toggle("1")} className={`btn btn-block btn-primary ${activeItem === "1" && "active"}`}>Redigering</button>
                </div>
            </div>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover table-sm">
                    <thead>
                        {activeItem === "2" && (
                            <tr>                                                     
                                <th>Hjemmelag</th>
                                
                                <th>HG</th>
                                <th>AG</th>
                                
                                <th>Bortelag</th>
                                <th>HP</th>
                                <th>AP</th>
                            </tr>
                        )}
                        {activeItem === "1" && (
                            <tr>                                                     
                                <th>Hjemmelag</th>
                                <th>HP</th>
                                <th>HG</th>
                                <th>AG</th>
                                <th>AP</th>
                                <th>Bortelag</th>
                                <th>Rediger</th>
                                <th>Slett</th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {results?.map((result, index) => {
                            return (
                                <SingleResultRound key={index} result={result} roundId={roundId} hostcupId={hostcupId} activeItem={activeItem} />
                            )
                        })}
                    </tbody>
                </table>

            </div>

        </React.Fragment>
    )

}
export default AllResultsRound